// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"R7-z"};